﻿'use strict';

angular.module('ntmApp').factory('WeeklyRecurrence', ['Recurrence', 'Constants', function (Recurrence, Constants) {

    function WeeklyRecurrence() {
        Recurrence.call(this);

        var self = this;

        var DEFAULT_VALUES = {
            startsOnDate: new Date(moment())
        };

        self.displaySchedulingLeeway = function () {
            return true;
        };

        self.displayOccurenceLimit = function () {
            return true;
        };

        self.displaySchedulingSettings = function () {
            return 'ng1/src/setup/recurrence/templates/scheduling-settings.html';
        };

        self.hideStartsOnDateBasedOnConditions = function () {
            return self.scheduleRacksOnDiffDays() && self.allowSetupRacks && parseInt(self.occurenceWeeklyTypeWithScheduledRacks) === Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value;
        };

        self.getSettingsTemplate = function () {
            return self.scheduleRacksOnDiffDays() ? 'ng1/src/setup/recurrence/templates/weekly-rack-settings.html' :
                                                    'ng1/src/setup/recurrence/templates/weekly-scheduling-settings.html';
        };

        self.getFieldsListForSave = function () {
            var fieldsList = self.getGeneralFieldsListForSave();

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    fieldsList.occursWeeklyType = self.occurenceWeeklyTypeWithScheduledRacks;
                    fieldsList.recurrenceRacks = getRackItemsFieldsForSave(self.rackItems);

                    if (parseInt(self.occurenceWeeklyTypeWithScheduledRacks) !== Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value) {
                        fieldsList.startsOnDate = self.startsOnDate;

                        if ((fieldsList.startsOnDate && fieldsList.startsOnDate.value) && (fieldsList.occurenceLimitEndsOnDate && fieldsList.occurenceLimitEndsOnDate.value)) {
                            fieldsList.dateStartAndDateEnd = [{ dateStart: self.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
                        }
                    }
                }
            } else {
                fieldsList.startsOnDate = self.startsOnDate;

                if ((fieldsList.startsOnDate && fieldsList.startsOnDate.value) && (fieldsList.occurenceLimitEndsOnDate && fieldsList.occurenceLimitEndsOnDate.value)) {
                    fieldsList.dateStartAndDateEnd = [{ dateStart: self.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
                }

                switch (parseInt(self.occurenceWeeklyType)) {
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value:
                        fieldsList.weekDays = self.selectedBiweeklyDowDays ? self.selectedBiweeklyDowDays : [];
                        fieldsList.biweeklyWeekNumber = self.biweeklyWeekNumber;
                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_dow.value:
                        fieldsList.everyNumbersOfWeeks = self.everyNumbersOfWeeks;
                        fieldsList.weekDays = self.selectedEveryDowDays ? self.selectedEveryDowDays : [];
                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:
                        fieldsList.everyNumbersOfDays = self.everyNumbersOfDays;
                        break;
                    default:
                        break;
                }
            }

            fieldsList.beforeLeeway = self.beforeLeeway;
            fieldsList.afterLeeway = self.afterLeeway;

            return fieldsList;
        };

        self.getRequestData = function () {

            var request = self.getGeneralRequestData();

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    request.occursWeeklyType = self.occurenceWeeklyTypeWithScheduledRacks;
                    request.recurrenceRacks = getRackItemsRequestInfo(self.rackItems);

                    if (parseInt(self.occurenceWeeklyTypeWithScheduledRacks) !== Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value) {
                        request.dateStart = self.startsOnDate.value;
                    }
                }
            } else {
                
                request.occursWeeklyType = self.occurenceWeeklyType;
                request.dateStart = self.startsOnDate.value;

                switch (parseInt(self.occurenceWeeklyType)) {
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value:
                        request.weekDays = self.getWeekDayDictionaryBySelectedDays(self.selectedBiweeklyDowDays);
                        request.biweeklyNumber = self.biweeklyWeekNumber;
                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_dow.value:
                        request.everyWeekly = self.everyNumbersOfWeeks.value;
                        request.weekDays = self.getWeekDayDictionaryBySelectedDays(self.selectedEveryDowDays);
                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:
                        request.everyDaily = self.everyNumbersOfDays.value;
                        break;
                    default:
                        break;
                }
            }

            request.beforeLeeway = self.beforeLeeway.value;
            request.afterLeeway = self.afterLeeway.value;

            return request;
        };

        self.applyDefaultInfo = function (data) {
            self.applyGeneralDefaultInfo(data);
        };

        self.setSpecificValues = function (data) {
            if (data.rackSplit === "Yes" && data.isScheduleRack) {
                self.occurenceWeeklyType = Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value;
                self.occurenceWeeklyTypeWithScheduledRacks = data.occursWeeklyType;
            } else {
                self.occurenceWeeklyType = data.occursWeeklyType;
                self.occurenceWeeklyTypeWithScheduledRacks = Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.value;

                self.selectedBiweeklyDowDays = self.occurenceWeeklyType === Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value ? self.getSelectedDaysFromDictionary(data.weekDays) : null;
                self.selectedEveryDowDays = self.occurenceWeeklyType === Constants.Recurrence.Patterns.WEEKLY.Options.Every_dow.value ? self.getSelectedDaysFromDictionary(data.weekDays) : null;
            }
        };

        self.setSpecificDefaultInfo = function () {
            if (self.occurenceWeeklyType === undefined || self.occurenceWeeklyType === null) {
                self.occurenceWeeklyType = Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value;
            }

            if (self.occurenceWeeklyTypeWithScheduledRacks === undefined || self.occurenceWeeklyTypeWithScheduledRacks === null) {
                self.occurenceWeeklyTypeWithScheduledRacks = Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.value;
            }
        };

        self.setSpecificDefaultRackItemsInfo = function () {
            if (self.rackItems && self.rackItems.length && self.rackItems.length) {
                self.rackItems.forEach(function (rackItem) {
                    if (!rackItem.startsOnDate) {
                        rackItem.startsOnDate = { value: DEFAULT_VALUES.startsOnDate };
                    } else if (rackItem.startsOnDate && !rackItem.startsOnDate.value) {
                        rackItem.startsOnDate.value = DEFAULT_VALUES.startsOnDate;
                    }
                });
            }
        };

        self.checkForDynamicRestricts = function (field, fieldName) {
            
            switch (fieldName) {
                case 'startsOnDate':
                    if (!self.scheduleRacksOnDiffDays() && 
                        (((parseInt(self.occurenceWeeklyType)) === Constants.Recurrence.Patterns.WEEKLY.Options.Every_dow.value) || ((parseInt(self.occurenceWeeklyType)) === Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value))) {

                        field.restricts.allowNullable = false;
                    }
                    else {
                        field.restricts.allowNullable = true;
                    }

                    break;
                default:
                    break;
            }
        };

        self.equals = function (recurrence) {

            if (!self.compareGeneralInfo(recurrence)) {
                return false;
            }

            if (!self.areDaysEqual(self.startsOnDate.value, recurrence.startsOnDate.value)) {
                return false;
            }

            if (parseInt(self.beforeLeeway.value) !== parseInt(recurrence.beforeLeeway.value)) {
                return false;
            }

            if (parseInt(self.afterLeeway.value) !== parseInt(recurrence.afterLeeway.value)) {
                return false;
            }

            if (!self.areDaysEqual(self.occurenceLimitEndsOnDate.value, recurrence.occurenceLimitEndsOnDate.value)) {
                return false;
            }

            if (self.scheduleRacks !== recurrence.scheduleRacks) {
                return false;
            }

            if (self.scheduleRacksOnDiffDays()) {

                if (parseInt(self.occurenceWeeklyTypeWithScheduledRacks) !== parseInt(recurrence.occurenceWeeklyTypeWithScheduledRacks)) {
                    return false;
                }

                if (self.rackItems && recurrence.rackItems) {

                    for (var i = 0; i < self.rackItems.length; i++) {

                        switch (parseInt(self.occurenceWeeklyTypeWithScheduledRacks)) {
                            case Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.value:

                                if (!self.compareSelectedDays(self.rackItems[i].selectedDays, recurrence.rackItems[i].selectedDays)) {
                                    return false;
                                }

                                if (parseInt(self.rackItems[i].weeklyCycleOption.value) !== parseInt(recurrence.rackItems[i].weeklyCycleOption.value)) {
                                    return false;
                                }

                                break;
                            case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:

                                if (parseInt(self.rackItems[i].everyNumbersOfDays.value) !== parseInt(recurrence.rackItems[i].everyNumbersOfDays.value)) {
                                    return false;
                                }

                                if (!self.areDaysEqual(self.rackItems[i].startsOnDate.value, recurrence.rackItems[i].startsOnDate.value)) {
                                    return false;
                                }

                                break;
                            default:
                                break;
                        }
                    }
                }

            } else {

                if (parseInt(self.occurenceWeeklyType) !== parseInt(recurrence.occurenceWeeklyType)) {
                    return false;
                }

                switch (parseInt(self.occurenceWeeklyType)) {
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Biweekly_Cycle.value:

                        if (self.selectedBiweeklyDowDays && recurrence.selectedBiweeklyDowDays && !self.compareSelectedDays(self.selectedBiweeklyDowDays, recurrence.selectedBiweeklyDowDays)) {
                            return false;
                        }

                        if ((self.selectedBiweeklyDowDays && !recurrence.selectedBiweeklyDowDays && self.selectedBiweeklyDowDays.length !== 0) || (!self.selectedBiweeklyDowDays && recurrence.selectedBiweeklyDowDays && recurrence.selectedBiweeklyDowDays.length !== 0)) {
                            return false;
                        }

                        if (parseInt(self.biweeklyWeekNumber) !== parseInt(recurrence.biweeklyWeekNumber)) {
                            return false;
                        }

                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_dow.value:

                        if (parseInt(self.everyNumbersOfWeeks.value) !== parseInt(recurrence.everyNumbersOfWeeks.value)) {
                            return false;
                        }

                        if (!self.compareSelectedDays(self.selectedEveryDowDays, recurrence.selectedEveryDowDays)) {
                            return false;
                        }

                        break;
                    case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:

                        if (parseInt(self.everyNumbersOfDays.value) !== parseInt(recurrence.everyNumbersOfDays.value)) {
                            return false;
                        }

                        break;
                    default:
                        break;
                }

            }

            return true;
        };

        function getRackItemsFieldsForSave(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {

                    switch (parseInt(self.occurenceWeeklyTypeWithScheduledRacks)) {
                        case Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.value:
                            return {
                                weekDays: self.getWeekDayDictionaryBySelectedDays(item.selectedDays),
                                weeklyCycleOption: parseInt(item.weeklyCycleOption.value)
                            };
                        case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:
                            var dateStartAndDateEndTemp = null;

                            if ((item.startsOnDate && item.startsOnDate.value) && (self.occurenceLimitEndsOnDate && self.occurenceLimitEndsOnDate.value)) {
                                dateStartAndDateEndTemp = [{ dateStart: item.startsOnDate, dateEnd: self.occurenceLimitEndsOnDate }];
                            }

                            return {
                                everyDaily: item.everyNumbersOfDays,
                                dateStart: item.startsOnDate,
                                dateStartAndDateEnd: dateStartAndDateEndTemp ? dateStartAndDateEndTemp : null
                            };
                        default:
                            break;
                    }
                });
            }

            return [];
        }

        function getRackItemsRequestInfo(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {
                    switch (parseInt(self.occurenceWeeklyTypeWithScheduledRacks)) {
                        case Constants.Recurrence.Patterns.WEEKLY.Options.Weekly_Cycle.value:

                            return {
                                ccrackID: item.ccrackID,
                                rackId: item.rackId,
                                cageCount: item.cageCount,
                                weekDays: self.getWeekDayDictionaryBySelectedDays(item.selectedDays),
                                weeklyCycleOption: parseInt(item.weeklyCycleOption.value)
                            };
                        case Constants.Recurrence.Patterns.WEEKLY.Options.Every_day.value:

                            return {
                                ccrackID: item.ccrackID,
                                rackId: item.rackId,
                                cageCount: item.cageCount,
                                everyDaily: item.everyNumbersOfDays.value,
                                dateStart: item.startsOnDate.value
                            };
                        default:
                            break;
                    }
                });
            }

            return [];
        }

        function initialize() {
            self.patternType = Constants.Recurrence.Patterns.WEEKLY.value;
            self.datePickerOptions = { datepickerMode: 'day', minMode: 'day', templateString: 'MMMM d, y' };
        }

        initialize();
    }

    WeeklyRecurrence.prototype = Object.create(Recurrence.prototype);
    WeeklyRecurrence.prototype.constructor = Recurrence;

    return (WeeklyRecurrence);

}]);